<div class="">
  <div class="divide-y divide-gray-200 overflow-hidden mt-5 bg-white shadow sm:rounded-lg">
    <div class="px-4 py-4 sm:px-6 inline-flex w-full justify-between select-none cursor-default">
      <span class="text-2xl leading-6  text-gray-900">
        Eventumsatz
      </span>
    </div>
    <div class="px-4 pb-1 mb-6 pt-0 sm:p-6">
      @if (timeSeriesPerformanceStore.analysisErrorState) {
        <div class="flex mt-7 h-96 w-full justify-content-center">
          @switch (timeSeriesPerformanceStore.analysisErrorState) {
            @case (ErrorCodes.loading) {
              <div
                class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status">
              </div>
            }
            @default {
              <div class="w-full flex justify-content-center">
                <analytics-error-message [analysisErrorState]="timeSeriesPerformanceStore.analysisErrorState"/>
              </div>
            }
          }
        </div>
      } @else {
        <div class="w-full  justify-content-center ">
          <div class="px-4 sm:px-6 lg:px-8 ">
            <div class="mt-8 flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <ul class="divide-y divide-gray-200">
                    @for (
                      monthGroup of eventTableStore.revenuePerMonthTableData | keyvalue : asIsOrder; track monthGroup.key) {
                      @if (monthGroup.value.eventEntries.length > 0) {
                        <!-- #234: `rounded-top-2`/`rounded-bottom-2` were Bootstrap's DIRECTIONAL radius family
                             (`var(--bs-border-radius)` = .375rem on the top/bottom corners, `!important`) — the same
                             trap as the plain `rounded-2` further down, just under a name the first sweep's token
                             list never looked for. `rounded-t-md`/`rounded-b-md` are the exact Tailwind equivalents
                             (.375rem, the same two corners each) and collide with nothing in bootstrap.min.css. -->
                        <div (click)="toggleMonthTab(monthGroup.value)"
                             [ngClass]="{'rounded-t-md': isBorderEvent(monthGroup.value.name)===2 || isBorderEvent(monthGroup.value.name)===3, 'rounded-b-md': isBorderEvent(monthGroup.value.name)===1 || isBorderEvent(monthGroup.value.name)===3}"
                             class="sticky  cursor-pointer flex top-0 z-10 border-y border-b-gray-200 border-t-gray-100 bg-gray-900 px-3 py-2.5 text-sm font-semibold leading-6 text-white">

                          <svg [ngClass]="{'rotate-90': isMonthTabOpen(monthGroup.value)}"
                               class="w-6 h-6 transition-all fill-none" stroke="currentColor"
                               stroke-width="1.5" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="w-full pl-2">{{ monthGroup.value.name }}</span>
                          <span>{{ getMonthRevenue(monthGroup.value).toFixed(2) | currency: "EUR" }}</span>
                        </div>

                        @for (event of getListOfEvents(monthGroup.value); track $index) {
                          @if (isMonthTabOpen(monthGroup.value)) {
                            <li [ngClass]="{'bg-gray-200': !event.isActive}">
                              <div class="flex justify-between gap-x-6 py-2 px-3 ">
                                <div class=" align-middle my-auto  col-start-1 flex min-w-0 gap-x-4">
                                  <div class="min-w-0 inline-flex ">
                                    <svg (click)="event.isOpen=!event.isOpen" [ngClass]="{'rotate-90': event.isOpen}"
                                         class="w-6 h-6 cursor-pointer transition-all fill-none"
                                         stroke="currentColor" stroke-width="1.5"
                                         viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                    </svg>

                                    <input (ngModelChange)="toggleInactive($event, event)"
                                           [id]="'cb_' + event.eventDto.id"
                                           [ngModel]="event.isActive"
                                           class="my-auto  h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer ml-2"
                                           type="checkbox">
                                    <p
                                      class="text-sm ml-3 font-semibold leading-6 text-gray-900">{{ event.eventDto.name }}</p>
                                  </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">

                                  <p
                                    class="text-sm leading-6 text-gray-900 ">
                                    {{ event.displayedRevenue | currency: "EUR" }}
                                  </p>
                                </div>

                              </div>

                              @if (event.isOpen) {
                                <div class="px-3 divide-y divide-gray-200 ml-8">
                                  <!--
                                    Bug #234: `border-1` + `rounded-2` were BOOTSTRAP utilities
                                    (`border-width:1px!important`, `border-radius:var(--bs-border-radius)
                                    !important` = .375rem). Tailwind's `rounded-md` is the exact same .375rem.

                                    The width is deliberately `border-[1px]` and NOT the bare `border`: in
                                    Bootstrap `.border` is a SHORTHAND —
                                    `border: var(--bs-border-width) var(--bs-border-style)
                                    var(--bs-border-color) !important` — so its `!important` covers the
                                    border-COLOUR too and would beat the `border-gray-200` sitting right next
                                    to it, repainting this frame Bootstrap grey (#dee2e6) instead of
                                    Tailwind's #e5e7eb. `border-[1px]` sets the width only and leaves the
                                    colour class alone. (`border-1` had the same width-only effect, which is
                                    why this stays a no-visual-change swap.) The border paints at all only
                                    because Tailwind's preflight sets a global `border-style: solid`.
                                  -->
                                  <div
                                    class="border-[1px] border-gray-200 mb-3 pb-2 pt-2 p-4  rounded-md divide-y divide-gray-200">

                                    <!--
                                      Bug #234: this carried `h-25` (Bootstrap `height:25%!important`), which was
                                      ALREADY inert — no ancestor up to the page container declares a height, so
                                      a percentage height computes to `auto` (CSS 2.1 §10.5). Translating it to
                                      `h-1/4` would only re-encode the same no-op, so the class is dropped and the
                                      block stays content-sized, which is what it has always rendered as.
                                    -->
                                    <div
                                      [ngClass]="{'mb-2 pb-2': hasRevenuePerLocation(event)|| hasRevenuePerPaymentMethod(event)}"
                                      class="w-full  shrink-0 flex flex-col">
                                      <div class="flex justify-between">

                                        <p
                                          class="text-sm leading-6 text-gray-900 ">Zeitraum:
                                          <br>{{ event.eventDto.start | date : globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME) }}
                                          - {{ event.eventDto.end | date : globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME) }}
                                        </p>


                                        <p
                                          (click)="openInNewTab(event)"
                                          class="cursor-pointer text-sm leading-6 text-indigo-900 "><br/>Detail-Analyse
                                        </p>
                                      </div>
                                    </div>

                                    <div class="mb-2 pt-4 grid grid-cols-1 xl:grid-cols-3 gap-2">
                                      <div class="w-full">
                                        <div class="w-full inline-flex ">
                                          <table class="min-w-full divide-y divide-gray-300">
                                            <thead class="bg-gray-50">
                                            <tr>
                                              <th
                                                class="pl-3 py-0.5 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Standort
                                              </th>
                                              <th
                                                class="px-3 py-0.5 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                                                Umsatz
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-200">
                                              @for (x of getRevenuePerLocation(event); track x.id) {
                                                <tr>
                                                  <td
                                                    class="whitespace-nowrap py-0.5  pr-3 text-sm font-medium text-gray-900 pl-3">{{ x.name }}
                                                  </td>
                                                  <td
                                                    class="whitespace-nowrap px-3 py-0.5 text-sm text-gray-500 text-right">{{ x.revenue | currency : "EUR" }}
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div class="w-full">
                                        <div class="w-full inline-flex ">
                                          <table class="min-w-full divide-y divide-gray-300">
                                            <thead class="bg-gray-50">
                                            <tr>
                                              <th
                                                class="pl-3 py-0.5 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Zahlungsart
                                              </th>
                                              <th
                                                class="px-3 py-0.5 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                                                Umsatz
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-200">
                                              @for (x of getRevenuePerPaymentMethod(event); track x.id) {
                                                <tr>
                                                  <td
                                                    class="whitespace-nowrap py-0.5  pr-3 text-sm font-medium text-gray-900 pl-3">{{ x.name }}
                                                  </td>
                                                  <td
                                                    class="whitespace-nowrap px-3 py-0.5 text-sm text-gray-500 text-right">{{ x.revenue | currency : "EUR" }}
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      @if (isRevenueBreakdownVisible(event)) {
                                        <div class="w-full">
                                          <dl class="px-2.5 text-sm leading-6">
                                            <div class="flex justify-between gap-x-4 pb-3">
                                              <dt class="text-gray-500">Umsatz</dt>
                                              <dd
                                                class="font-medium text-gray-900">{{ event.revenue | currency: "EUR" }}
                                              </dd>
                                            </div>
                                            <table class="w-full border-t-2 border-b-2 border-grey-900"
                                                   style="padding: .5rem .5rem;">
                                              <tr class="">
                                                <th class="text-gray-500   ">
                                                  <div class="  px-0">Steuern</div>
                                                </th>
                                                <td class="text-right py-2">
                                                  <div
                                                    class="text-gray-900 px-0">{{ (timeSeriesPerformanceStore.isNetRevenue ? -(event.revenue - event.netRevenue) : 0) | currency: "EUR" }}
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="">
                                                <th class="text-gray-500  ">
                                                  <div class="  px-0">Personalkosten</div>
                                                </th>
                                                <td class="text-right py-2">
                                                  <div
                                                    class=" text-gray-900 px-0 ">{{ (timeSeriesPerformanceStore.isEmployeeCostsIncluded ? -event.employeeCosts : 0) | currency: "EUR" }}
                                                  </div>
                                                </td>
                                              </tr>
                                            </table>
                                            <div class="flex justify-between gap-x-4 py-3">
                                              <dt class="text-gray-500">vorl. Gewinn</dt>
                                              <dd class="font-medium text-gray-900">
                                                = {{ (timeSeriesPerformanceStore.isNetRevenue ? event.netRevenue : event.revenue) + (timeSeriesPerformanceStore.isEmployeeCostsIncluded ? -event.employeeCosts : 0) | currency: "EUR" }}
                                              </dd>
                                            </div>
                                          </dl>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              }
                            </li>
                          }
                        }
                      }
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>



